<template>
  <div class="iframe-wrap">
    <!-- 路由参数 url 传递外部地址 -->
    <!-- <iframe
      :src="targetUrl"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe> -->
  </div>
</template>

<script>
export default {
  name: 'IframePage',
  computed: {
    targetUrl() {
      // 从路由 params / query 获取外链地址
      const url = `https://jsc.yundongm.cn/#/integratedData?association_token=${sessionStorage.getItem('token')}`
      // 简单校验防止空地址
      return url
    }
  },
  mounted() {
    console.log('targetUrl', this.targetUrl)
    //  打开网址在新窗口
    window.open(this.targetUrl, '_blank')
    //  关闭当前路由
    this.$router.push('/shouye')
  },
  activated() {
    //  组件激活时，重新打开网址
    window.location.reload(this.targetUrl, '_blank')
    //  关闭当前窗口
    this.$router.push('/shouye')
  }
}
</script>

<style scoped>
.iframe-wrap {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}
iframe {
  display: block;
}
</style>